import Vue from 'vue'
import msal from 'vue-msal'
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
Vue.use(msal, {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_MSAL_TENANT_ID}`,
    redirectUri: `${window.location.origin}/login`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: isSafari ? "sessionStorage" : "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: !isSafari, // Set this to "true" if you are having issues on IE11 or Edge
  },
})
